import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import { TableOtroSiDataSource, TableOtroSiItem } from './table-otro-si-datasource';

@Component({
  selector: 'app-table-otro-si',
  templateUrl: './table-otro-si.component.html',
  styleUrls: ['./table-otro-si.component.scss']
})
export class TableOtroSiComponent implements AfterViewInit, OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<TableOtroSiItem>;
  dataSource: TableOtroSiDataSource;

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns = ['numero', 'fecha_creacion', 'acciones'];

  ngOnInit() {
    this.dataSource = new TableOtroSiDataSource();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.table.dataSource = this.dataSource;
  }

  ejecutarFuncion(funcion = '') {
    alert('Thanks');
  }
}
